import { Brand, brandDisplayName } from 'common/Brand';
import { useBrand } from 'src/shared/hooks/useBrand';

export const DEFAULT_SIGN_UP_CTA = 'Sign up';

export function termsConsentSentence(brand: Brand, cta: string = DEFAULT_SIGN_UP_CTA): string {
  return `By selecting "${cta}" you agree to ${brandDisplayName(brand)}'s `;
}

export const useTermsConsentSentence = (cta: string = DEFAULT_SIGN_UP_CTA): string =>
  termsConsentSentence(useBrand(), cta);
